export class HrOffer {
    id!: string
    position!: string
    name!: string
    offerDate!: Date
    startDate!: Date
}
